{
  "auth": {
    "checkingSession": "Checking your session..."
  },
  "authLayout": {
    "logoAlt": "Constructions-3D's logo"
  },
  "errors": {
    "accepted": "The format of this field is invalid",
    "blank": "This field cannot be blank",
    "confirmation": "This field should match the password",
    "empty": "This field cannot be empty",
    "equalTo": "The format of this field is invalid",
    "even": "The format of this field is invalid",
    "exclusion": "The format of this field is invalid",
    "greaterThan": "The format of this field is invalid",
    "greaterThanOrEqualTo": "The format of this field is invalid",
    "in": "The format of this field is invalid",
    "inclusion": "The format of this field is invalid",
    "invalid": "This field is invalid",
    "invalidCredentials": "Invalid credentials",
    "invalidEmail": "Invalid email format",
    "lessThan": "The format of this field is invalid",
    "lessThanOrEqualTo": "The format of this field is invalid",
    "minLength": "This field must be at least 8 characters long",
    "modelInvalid": "The model of this field is invalid",
    "notAnInteger": "This fields must be a integer",
    "notANumber": "This fields must be a number",
    "odd": "The format of this field is invalid",
    "otherThan": "The format of this field is invalid",
    "passwordsMatch": "Passwords don't match",
    "passwordSpecialChars": "This password must contain at least one special character",
    "passwordTooLong": "This password is too long",
    "passwordUppercase": "This password must contain at least one uppercase letter",
    "present": "The format of this field is invalid",
    "required": "This field is required",
    "sceneNotSaved": "Are you sure you want to leave? Your changes haven't been saved yet.",
    "taken": "This value is already taken",
    "tooLong": "This value is too long",
    "tooShort": "This value is too short",
    "wrongLength": "This value is the wrong lenght"
  },
  "footer": {
    "copyright": {
      "rights": "All rights reserved.",
      "year": "Copyright © {{ year }} Constructions-3D."
    },
    "sections": {
      "contactUs": {
        "title": "Contact us"
      },
      "legal": {
        "links": {
          "cookiePolicy": "Cookie policy",
          "privacyPolicy": "Privacy policy",
          "termsOfUse": "Terms of use"
        },
        "title": "Legal informations"
      }
    },
    "theme": {
      "dark": "Dark",
      "light": "Light",
      "system": "System"
    }
  },
  "forgotPassword": {
    "checkInbox": "Please check your inbox and follow the instructions to reset your password.",
    "emailSent": "A password reset email has been sent to",
    "links": {
      "signin": "Sign in",
      "signup": "Create an account"
    },
    "metaTitle": "Reset your password · Printsite Studio",
    "submit": "Reset password",
    "title": "Reset your password for Printsite Studio"
  },
  "form": {
    "currentPasswordLabel": "Current password",
    "emailLabel": "Email",
    "emailPlaceholder": "example@domain.com",
    "hidePassword": "Hide password",
    "passwordConfirmationLabel": "Confirm password",
    "passwordLabel": "Password",
    "showPassword": "Show password"
  },
  "globals": {
    "cancel": "Cancel",
    "help": "Help",
    "no": "No",
    "save": "Save",
    "yes": "Yes",
    "machine": "Machine"
  },
  "loading": "Loading...",
  "navbar": {
    "documentation": {
      "tooltip": "Documentation center"
    },
    "dropdown": {
      "backToProjects": "Back to projects",
      "renameProject": "Rename",
      "settings": "My account",
      "shareProject": "Send a copy",
      "signout": "Sign out"
    },
    "help": {
      "tooltip": "Get help"
    },
    "searchPlaceholder": "Search a project...",
    "signIn": "Sign in",
    "signUp": "Register"
  },
  "project": {
    "back": "Back to projects",
    "camera": {
      "reset": "Reset camera",
      "togglePerspective": "Toggle {{type}} camera",
      "type": {
        "orthographic": "Orthographic projection [C]",
        "perspective": "Perspective projection [C]"
      }
    },
    "created": "Created by {{username}} at {{date}}",
    "error": "An error occurred while loading this project. Please try again later.",
    "island": {
      "addPrinter": {
        "cancel": "Cancel placement [Esc]",
        "tooltip": "Add a {{label}}"
      },
      "default": "Selection [Esc]",
      "rotate": "Rotation [R]",
      "translate": "Translation [G]"
    },
    "leftBar": {
      "files": {
        "contextMenu": {
          "assignTo": "Assign to",
          "delete": "Delete",
          "focus": "Focus",
          "noPrinter": "No machine",
          "rename": "Rename",
          "split": "Split by contour"
        },
        "emptyState": {
          "buttonLabel": "Upload a file",
          "subtitle": "Your project has no file yet. Add a file by clicking on the button below.",
          "title": "No file yet."
        }
      },
      "groups": {
        "contextMenu": {
          "delete": "Delete",
          "focus": "Focus",
          "rename": "Rename"
        },
        "title": "Files"
      },
      "printers": {
        "add": "Add a machine (m)",
        "contextMenu": {
          "delete": "Delete",
          "focus": "Focus",
          "rename": "Rename"
        },
        "emptyState": {
          "buttonLabel": "Add a machine",
          "subtitle": "Your project has no machine yet. Add a machine by clicking on the button below.",
          "title": "No machine yet."
        },
        "title": "Machines",
        "unassignedFiles": "Unassigned files",
        "upload": "Upload file [Ctrl+I]"
      }
    },
    "loadingState": {
      "fileTooLarge": "File is too large (max 200 MB)",
      "finalizingFile": "Finalizing import...",
      "importingFile": "Importing your files...",
      "loadingProject": "Loading your project...",
      "parsingFile": "Parsing file structure...",
      "processingFile": "Processing geometry...",
      "readingFile": "Reading file...",
      "savingProject": "Saving your project...",
      "uploadError": "Upload failed"
    },
    "metaTitle": "{{projectName}} · Printsite Studio",
    "modes": {
      "default": "Positioning",
      "forbiddenZone": "Forbidden zones",
      "seam": "Seam positions"
    },
    "name": "Name",
    "navbar": {
      "save": {
        "save": "Save",
        "saving": "Saving..."
      }
    },
    "positioningAssistant": {
      "back": "Back",
      "next": "Next",
      "steps": {
        "file": {
          "info": "1 file corresponds to 1 set of coordinates",
          "instruction": "Select or import a file and a CAD file"
        },
        "introduction": {
          "description": "Automatically aligns machines from CAD coordinates and real measurements — without manual adjustment.",
          "instructions1": "Import the project",
          "instructions2": "Add the machines",
          "instructions3": {
            "description": "Import the CAD file and machine files (.csv or .dxf)",
            "details1": {
              "highlight": "1 CAD file",
              "text": " corresponds to 1 set of coordinates"
            },
            "details2": {
              "highlight": "Add printers",
              "text": " if needed"
            },
            "details3": {
              "highlight": "automatic detection",
              "prefix": "No manual assignment: ",
              "suffix": " via G-code"
            }
          }
        },
        "machine": {
          "instruction": "Select the machine and import the coordinates"
        },
        "resume": {
          "title": "Discover the results"
        }
      },
      "title": "Positioning Assistant"
    },
    "rightBar": {
      "emptyState": {
        "subtitle": "You haven't selected any element. Select an element by clicking on it in the workspace or in the list of machines / files on the left",
        "title": "No element selected."
      },
      "export": {
        "action": "Download the Gcode"
      },
      "position": {
        "dropToFloor": "Drop to floor",
        "rotation": "Rotation",
        "title": "Position",
        "translation": "Translation"
      },
      "positioningAssistant": {
        "inputLabel": "CAO File",
        "inputPlaceholder": ".csv or .dxf file",
        "run": "Run positioning assistant",
        "selectFile": "Select a file...",
        "title": "Positioning Assistant"
      },
      "preview": {
        "action": "Preview the Gcode",
        "pending": "Preparing preview..."
      },
      "multiSelection": {
        "description": "Assign all selected files to the same machine",
        "title": "{{count}} items selected"
      },
      "printerAssignment": {
        "description": "Assign a machine",
        "noPrinter": "No machine",
        "title": "Assignment"
      },
      "printerSettings": {
        "title": "Machine settings",
        "options": {
          "head": "Print head",
          "head_1k": "1K",
          "head_2k": "2K"
        }
      },
      "zoneSettings": {
        "area": {
          "full": "Full",
          "half": "Half",
          "none": "None",
          "title": "Area"
        },
        "grid": {
          "cartesian": "Cartesian",
          "none": "None",
          "polar": "Polar",
          "title": "Grid"
        },
        "settings": {
          "boom": "Boom",
          "height": "Height",
          "jib": "Jib",
          "title": "Machine settings"
        },
        "title": "Machine area",
        "zone": {
          "printable": "Printable",
          "reachable": "Reachable",
          "title": "Zone"
        }
      },
      "printSettings": {
        "avoidInsideTravelling": "Prevent travelling inside the file",
        "avoidInsideTravellingMarginMm": "Overflow (in mm)",
        "invertPrintDirection": "Reverse print direction",
        "layerHeight": "Layer height",
        "layersAmount": "Layers count",
        "layersGroupAmount": "Number of layers per group",
        "layersGroupAmountTooltip": "The number of layers per group allows you to sequence the print of the file during printing",
        "spiralMode": "Printing mode",
        "spiralModes": {
          "off": "Regular",
          "semiSpiral": "Semi-spiralized",
          "spiral": "Spiralized"
        },
        "title": "Print settings",
        "tooltip": "Configure here your print settings",
        "totalHeight": "Total height"
      },
      "size": {
        "height": "Height",
        "length": "Length",
        "title": "Size",
        "width": "Width"
      },
      "forbiddenZone": {
        "delete": "Delete zone",
        "height": "Height (mm)",
        "title": "Forbidden zone"
      }
    },
    "savedTimeAgo": "Saved {{ timeAgo }}",
    "savedJustNow": "Just saved",
    "saving": "Saving...",
    "emptyProjectModal": {
      "descriptions": {
        "maxiprinter": "Large format printing",
        "miniprinter-l": "Compact printing",
        "miniprinter-xl": "Compact printing for larger projects"
      },
      "importFile": {
        "description": "Add a file without choosing a machine",
        "title": "Import a file"
      },
      "submit": "Continue",
      "title": "Create a new project"
    },
    "shareModal": {
      "button": "Send a copy of your project",
      "close": "Close",
      "instructions1": "Send a copy of your project to another user by typing their email address in the field below.",
      "instructions2": "Please note that this user must already have an account on the platform.",
      "noteLabel": "Message (optional)",
      "notePlaceholder": "Add a message to go with the project…",
      "successMessage": "A copy of your project has been sent to {{ userEmail }}.",
      "title": "Send a copy of the project"
    },
    "updated": "Updated at {{date}}",
    "zone": {
      "toggle": "Toggle zone",
      "toggleSlice": "Toggle {{type}} zone",
      "type": {
        "full": "full",
        "sliced": "sliced"
      }
    }
  },
  "projectPreview": {
    "backToEditor": "Back to editor",
    "displayGcode": "GCode",
    "errorState": {
      "retryButton": "Retry",
      "subtitle": "An error occurred while generating the gcode preview. Please try again.",
      "title": "Unable to load the gcode preview"
    },
    "export": "Download",
    "loadingState": {
      "buildingPreview": "Building the preview…",
      "loadingGcode": "Slicing in progress..."
    },
    "metaTitle": "{{projectName}} · {{printerName}} · Printsite Studio",
    "navbar": {
      "downloadGcode": {
        "idle": "Download the Gcode",
        "pending": "Download in progress..."
      }
    },
    "settings": {
      "displayG0": "Display G0",
      "title": "Settings"
    },
    "statistics": {
      "form": {
        "layerWidth": "Layer width (in mm)",
        "priceBigBag": "Material price (€ / big bag)",
        "printSpeed": "Print speed (in mm/s)"
      },
      "freshMortarMass": {
        "kg": "kg",
        "label": "Fresh mortar mass",
        "t": "t"
      },
      "freshMortarVolume": {
        "label": "Fresh mortar volume",
        "m3": "m³"
      },
      "liftSpeed": {
        "cmh": "cm/h",
        "label": "Average lift speed"
      },
      "materialLength": {
        "label": "Print length",
        "m": "m"
      },
      "materialVolume": {
        "bigbag": "big bags"
      },
      "materialWeight": {
        "kg": "kg",
        "label": "Dry material required",
        "t": "t"
      },
      "price": {
        "label": "Project cost"
      },
      "printingTime": {
        "hours": "h",
        "label": "Print duration",
        "minutes": "m"
      },
      "title": "Statistics",
      "waterVolume": {
        "l": "L",
        "label": "Water volume"
      }
    }
  },
  "projects": {
    "emptyState": {
      "buttonLabel": "Create a project",
      "subtitle": "You haven't created a project yet. Click the button below to create your first project.",
      "title": "No project yet."
    },
    "error": "An error occurred while loading your projects. Please try again later.",
    "filters": {
      "dateCreated": "Date created",
      "lastModified": "Last modified",
      "name": "Name"
    },
    "layouts": {
      "grid": "Grid view",
      "list": "List view"
    },
    "metaTitle": "Projects · Printsite Studio",
    "new": "New project",
    "noProjects": "You don't have any projects yet. Create your first project to get started!",
    "project": {
      "edited": "Edited {{editedAt}}"
    },
    "sortBy": "Sort by:",
    "title": "My projects"
  },
  "resetPassword": {
    "invalidToken": "This password reset link is invalid or has expired. Please request a new password reset link.",
    "links": {
      "signin": "Sign in",
      "signup": "Create an account"
    },
    "metaTitle": "Create a password · Printsite Studio",
    "submit": "Change password",
    "success": "Your password has been successfully changed. You can now sign in with your new password.",
    "title": "Create a new password for Printsite Studio"
  },
  "settings": {
    "metaTitle": "Settings",
    "signOut": {
      "button": "Sign out",
      "description": "Close my session",
      "explanation": "You can sign out by clicking the button below.",
      "title": "Sign out"
    },
    "title": "Settings"
  },
  "signin": {
    "links": {
      "extras": {
        "noAccount": "Don't have an account yet?"
      },
      "forgotPassword": "Forgot password?",
      "signup": "Create one"
    },
    "metaTitle": "Sign in · Printsite Studio",
    "signInWithC3D": "Sign in with Constructions-3D",
    "title": "Sign in to Printsite Studio"
  },
  "signup": {
    "links": {
      "extras": {
        "alreadySignedUp": "Already have an account?"
      },
      "signin": "Sign in"
    },
    "metaTitle": "Sign up · Printsite Studio",
    "submit": "Create account",
    "title": "Create an account on Printsite Studio"
  },
  "testEnvBanner": {
    "message": "You are in the {{ env }} environment"
  }
}
